import React, { useEffect } from 'react';

const Loader = () => {

    useEffect(() => {
        document.querySelector('body')!.classList.add('no-scroll');
        return () => {
            document.querySelector('body')!.classList.remove('no-scroll');
        }
    }, [])


    return (
        <div id="loading" className="loading" style={{ display: 'flex' }}>
            <div className="loading-box">
                <div className="loading-spinner">
                </div>
                <div className="loading-text">Loading...</div>
            </div>
        </div>
    )

}
export default Loader;